export default __webpack_public_path__ + "static/media/bd-exec-1.0471d52e.jpg";